import kaboom from "../lib/kaboom.mjs";

const k = kaboom({
  width: window.innerWidth,
    height: window.innerHeight,
    scale: 1,
    canvas: document.querySelector("canvas"),
    stretch: true,
    letterbox: true,
});

export default k;
